"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.trackPageView = function (eventDef) {
  var trackers = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    trackers[_i - 1] = arguments[_i];
  }

  return function (action, prevState, nextState) {
    var event = eventDef(action, prevState, nextState);
    return {
      type: 'page',
      trackingId: trackers,
      page_title: event.title,
      page_location: event.location,
      page_path: event.path
    };
  };
};

exports.trackEvent = function (eventDef) {
  return function (action, prevState, nextState) {
    var event = eventDef(action, prevState, nextState);
    return {
      type: 'event',
      action: event.action,
      event_category: event.category,
      event_label: event.label,
      value: event.value
    };
  };
};